import auth from '../authentication'

export const getAccessToken = () =>
{
    return auth.getAccessToken();
}
